import { Injectable } from '@angular/core';
import { AuthViewModel } from '../auth/auth.view-model';
import { Router } from '@angular/router';
import { AuthState } from '../auth/model/auth-state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RouteManagerService {
  private monitoring$ = new Subject<boolean>();

  constructor(
    private authViewModel: AuthViewModel,
    private router: Router,
  ) {}

  public startManagement(queryParams?: { fhirAuthorizeError: true } | undefined): void {
    this.authViewModel.authState$
      .pipe(takeUntil(this.monitoring$))
      .subscribe((state) => this.handleAuthState(state, queryParams));
  }

  public stopManagement(): void {
    this.monitoring$.next(true);
  }

  private handleAuthState(
    state: AuthState,
    queryParams?: { fhirAuthorizeError: true } | undefined,
  ): void {
    this.router
      .navigate([`/${state}`], {
        queryParamsHandling: 'merge',
        queryParams,
      })
      .then();
  }
}
